import React, { useState, useEffect } from 'react';

import { notification, Select, Typography, Switch } from 'antd';

import { useIntl } from 'react-intl';

import _service from '@netuno/service-client';

import './index.less';

const langContext = 'components.service-select';

const { Paragraph } = Typography;

export default (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [ellipsis, setEllipsis] = useState(true);

    useEffect(() => {
        setLoading(true);
        _service({
            url: "/service/list",
            success: (response) => {
                setLoading(false);
                setData(response.json);
            },
            fail: (e) => {
                notification["error"]({
                    message: intl.formatMessage({id: `${langContext}.error.message`}),
                    description: e.response.json.error,
                });
            }
        });
    }, []);

    const intl = useIntl();

    return (

        <Select placeholder={intl.formatMessage({ id: `${langContext}.placeholder` })} loading={loading} {...props}>
            {
                data.map((item, key) => (

                    <Select.Option key={key} value={item.uid}><p>Code: {item.code} <br /> Waste Type: {item.waste_type.description[intl.locale.split('-')[0]]}<br /><span>Service Type: {item.service_type.description[intl.locale.split('-')[0]]}</span></p></Select.Option>

                ))
            }
        </Select>
    );
};

